/**
 * Permisos RBAC por modulo. FUENTE UNICA DE VERDAD.
 *
 * La usan a la vez el Sidebar (para decidir que entradas se ven) y ModuleGuard
 * (para decidir a que rutas se puede entrar). Antes cada uno tenia su propia
 * lista y se desincronizaron: el menu de ADMINISTRADORES aparecia con
 * cualquiera de los cuatro permisos `admin.*`, pero la ruta exigia
 * concretamente `admin.users`, asi que al pulsar rebotaba a /system sin decir
 * nada. Con un solo mapa eso no puede repetirse.
 *
 * Cada entrada es prefijo de ruta -> permiso (string) o permisos (array,
 * basta con tener uno). Se evalua el prefijo MAS LARGO que encaje, por eso
 * el orden importa: las rutas mas especificas van primero.
 */

export const MODULE_PERMISSIONS = [
  // --- Administracion: cada pestana tiene su propio permiso ---
  { path: '/system/admin/usuarios', permission: 'admin.users' },
  { path: '/system/admin/roles', permission: 'admin.roles' },
  { path: '/system/admin/permisos', permission: 'admin.permissions' },
  { path: '/system/admin/configuracion', permission: 'admin.settings' },
  { path: '/system/admin', permission: ['admin.users', 'admin.roles', 'admin.permissions', 'admin.settings'] },

  // --- Modulos de negocio ---
  { path: '/system/ventas', permission: 'ventas.view' },
  { path: '/system/facturacion', permission: 'ventas.invoices' },
  { path: '/system/clientes', permission: 'clientes.view' },
  { path: '/system/productos', permission: 'productos.view' },
  { path: '/system/formulaciones', permission: 'productos.formulas' },
  { path: '/system/inventario', permission: 'inventario.view' },
  { path: '/system/proveedores', permission: 'proveedores.view' },
  { path: '/system/compras', permission: 'ordenes.view' },
  { path: '/system/seguimiento', permission: 'seguimiento.view' },
  { path: '/system/prospeccion', permission: 'seguimiento.view' },
  { path: '/system/vendedores', permission: 'vendedores.view' },
  { path: '/system/procesos', permission: 'produccion.view' },
  { path: '/system/registros', permission: 'produccion.view' },
  { path: '/system/ordenes', permission: 'ventas.view' },
  { path: '/system/reportes', permission: 'reportes.view' },
];

/**
 * Permiso requerido por una ruta, o null si la ruta no exige ninguno
 * (el dashboard de /system y el portal del cliente).
 */
export const getRequiredPermission = (pathname) => {
  const match = MODULE_PERMISSIONS
    .filter((m) => pathname === m.path || pathname.startsWith(`${m.path}/`))
    .sort((a, b) => b.path.length - a.path.length)[0];

  return match ? match.permission : null;
};

/**
 * Comprueba un permiso que puede ser string o array (any-of).
 * `hasPermission` viene de useAuth().
 */
export const checkPermission = (permission, hasPermission) => {
  if (!permission) return true;
  if (Array.isArray(permission)) return permission.some((p) => hasPermission(p));
  return hasPermission(permission);
};
